import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";

import AutoCompleteDropdown from "../../../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../../Base/Services/ToastService";

import { addEstante, getEstantes } from "../../../../../API/Suministros/SuministrosRequest";
import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests";
import { getBodegasAct } from "../../../../../API/Suministros/SuministrosRequest"; 
import { InputNumber } from "primereact/inputnumber";
import Loader from "../../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";


const EstantesCrudModal = ({
  estante,
  estantesDialog,
  setEstantesDialog,
  toastRef,
  getEst,
  modo,
}) => {
  const toastDialog = useRef(null);
  const toast = useRef(null);

  const [show, setShow] = useState(false);

  const [estados, setEstados] = useState([{}]);
  const [estanteList, setEstanteList] = useState([{}]);
  const [bodegas, setBodegas] = useState([{}]);
  const [loading, setLoading] = useState(false);
  const { userAuth } = useContext(AuthContext);

  // Inicializamos el formulario con los valores del estante si estamos en modo "Editar", o con valores vacíos si estamos en modo "Crear"
  const initialValues = {
    IdEstante: -1,
    NombreEstante: "",
    NumeroEstante: "",
    IdStatus: estante ? estante?.IdStatus : 5,
    IdBodega: "",
  };
  
  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);
  // useEffect para actualizar los valores del formulario cuando el estante cambia (por ejemplo, al abrir el modal en modo "Editar")
  const getValoresIniciales = async () => {
    setLoading(true)
    const bodegasActiva = await getBodegasAct();
    const estadosTempo = await getEstadosCategory("General");
    const Estantes = await getEstantes();

    setEstanteList(Estantes);
    setBodegas(bodegasActiva);
    setEstados(estadosTempo);

    // Si el modo es "Crear", establece el primer estado como valor inicial
    const estadoInicial =
      modo === "Crear"
        ? estadosTempo[0]
        : estadosTempo.find((e) => e.IdStatus === estante?.IdStatus);

    setValues({
      ...estante,
      Estado: estadoInicial, // Establece el estado inicial
      IdStatus: estadoInicial.IdStatus, // Establece el IdStatus en values

      Bodega: bodegasActiva.find((c) => estante?.IdBodega === c.IdBodega), 
      IdUserCreate: userAuth?.IdUser
    });
    setLoading(false)
  };

  const onHide = () => {
    setEstantesDialog(false);
    resetForm();
    setShow(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.NombreEstante) {
      error.NombreEstante = true;
      error.error = true;
    }
    if (!values.NumeroEstante) {
        error.NumeroEstante = true;
        error.error = true;
      }
    if (!values.Bodega || !values.Bodega?.IdBodega) {
      error.IdBodega = true;
      error.error = true;
    }
    if (!values.Estado || !values.Estado.IdStatus) {
      error.IdStatus = true;
      error.error = true;
    }
    setError(error);
    return error;
  };
  // Función para verificar si ya existe un estante con el mismo nombre en la misma bodega (excluyendo el estante actual en modo "Editar")
  const estanteExistsWithSameName = () => {
    const sameNameEstantes = estanteList.filter(
      (item) =>
        item.NombreEstante.toLowerCase() === values.NombreEstante.toLowerCase() &&
        item.IdBodega === values.Bodega.IdBodega &&
        item.IdEstante !== values.IdEstante
    );
    return sameNameEstantes.length > 0;
  };
  // Función para verificar si ya existe un estante con el mismo número en la misma bodega (excluyendo el estante actual en modo "Editar")
  const estanteExistsWithSameNumber = () => {
    const sameNumberEstantes = estanteList.filter(
      (item) =>
        Number(item.NumeroEstante) === Number(values.NumeroEstante) &&
        item.IdBodega === values.Bodega.IdBodega &&
        item.IdEstante !== values.IdEstante
    );

    return sameNumberEstantes.length > 0;
  };
  // Función para agregar o modificar un estante dependiendo del modo, con validación previa y mostrando mensajes de éxito o error
  const agregarEstante = async () => {
    const e = verificarInfo();

    if (!e.error) {
        if (estanteExistsWithSameName()) {
            toastShow(toast, "error", "Error", "Ya existe un estante con el mismo nombre en esta bodega.");
            return;
          }
        if (estanteExistsWithSameNumber()) {
          toastShow(toast,"error", "Error", "Ya existe un estante con el mismo número en esta bodega.");
          return;
        }  

        let estadoId = null;
        if (values.Estado) {
          estadoId = values.Estado.IdStatus;
        }
        const a = {
          IdEstante: values?.IdEstante, 
          NombreEstante: values.NombreEstante,
          NumeroEstante: values?.NumeroEstante,
          IdBodega: values.Bodega.IdBodega,
          IdStatus: estadoId,
          IdUserCreate: userAuth.IdUser
        };
        
        const resultado = await addEstante(a);
        if (modo === "Crear") {
            onHide();
            toastShow(toast, "success", 'Datos Agregados', "Estante Agregado exitosamente.");
            getEst();
          } else {
            onHide();
            toastShow(toastRef, "success", 'Datos Modificados',"Estante modificado exitosamente.");
            getEst();
          }

      }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          console.log("ABRIENDO MODAL ESTANTE");
          if (modo === "Crear") {
            agregarEstante();
          } else {
            agregarEstante();
          }
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (estantesDialog) {
      getValoresIniciales();
    }
  }, [estantesDialog]);

  const dialogTitle = modo === "Crear" ? "Agregar Estante" : "Modificar Estante";
  
  return (
    <div>
      <Dialog
        visible={estantesDialog}
        modal={false}
        className="modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
        appendTo="self"
        style={{ width: "55vw" }}
      >
        <div id="Dialog">
        <Loader loading={loading} querySelector={"#Dialog"} />
        <div style={{ width: "100", margin: "auto" }}>
          <div className="d-flex align-items-center">
            <h2 className="me-3">{dialogTitle}</h2>
          </div>
          <Toast ref={toastDialog} style={{ zIndex: 50000 }} />
          <Toast ref={toast} style={{ zIndex: 50000 }} />

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="NombreEstante"
                  value={values.NombreEstante}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.NombreEstante ? "p-invalid" : ""}
                />
                <label htmlFor="NombreEstante">Nombre del Estante</label>
              </span>
            </div>

            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputNumber
                  name="NumeroEstante"
                  value={values.NumeroEstante}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.NumeroEstante ? "p-invalid" : ""}
                  useGrouping={false}
                />
                <label htmlFor="NumeroEstante">Número</label>
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">

              <div className="field col-6 me-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"Estado"}
                  value={values.Estado}
                  items={estados}
                  field={"StatusName"}
                  label={"Estado"}
                  handleInputChange={handleInputChange}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.IdStatus ? "p-invalid" : ""}
                />
              </span>
            </div>


            <div className="field col-6 me-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"Bodega"}
                  value={values.Bodega}
                  items={bodegas}
                  field={"NombreBodega"}
                  label={"Bodega"}
                  handleInputChange={handleInputChange}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.IdBodega ? "p-invalid" : ""}
                />
              </span>
            </div>

          </div>
        </div>

        </div>
      </Dialog>
    </div>
  );
};

export default EstantesCrudModal;
